import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Animators = (props) => { 
    return (
        <div></div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Animators);
